<!-- 由 suu 创建于 2021-07-06 星期二 -->
<!-- 食品详情-->
<template>
  <div>
    <AppBar title="食物档案" :placeholder="true" :zIndex="10"> </AppBar>
    <van-list
      class="van-list"
      v-model="loading"
      :finished="finished"
      finished-text=""
      @load="getSuperMenu"
    >
      <div class="food-info" v-if="info">
        <!-- 上方信息 -->
        <TopInfo :info="info"></TopInfo>
        <!-- 资源位 -->
        <AdvComponent
          class="adv-content"
          :data="advData"
          :background="advBackground"
        />
        <!-- 热量 -->
        <heatInfo :info="info.calorie"></heatInfo>
        <!-- 营养 -->
        <NutritionInfo :info="info.nutrition"></NutritionInfo>
        <!-- 排行  单位重量 血糖相关-->
        <OtherInfo :info="info"></OtherInfo>
        <ConsultCard />
        <SuperMenu
          class="super-menu"
          v-if="superMenuList.length"
          :data="superMenuList"
        ></SuperMenu>
        <div class="tip"
          >数据信息源自：<br />中国食物成分表标准版（第6版）2019年出版</div
        >
      </div>
    </van-list>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>

<script>
import AppBar from '@/components/app/nav-bar/index.vue'
import TopInfo from './ponents/top-info.vue'
import HeatInfo from './ponents/heat-info.vue'
import NutritionInfo from './ponents/nutrition-info.vue'
import OtherInfo from './ponents/other-info.vue'
import SuperMenu from './ponents/super-menu.vue'
import AdvComponent from '@/components/app/advertisement/advertisement.vue'
import ConsultCard from './ponents/consult-card.vue'
export default {
  name: 'calorie-query-info',

  components: {
    TopInfo,
    HeatInfo,
    NutritionInfo,
    OtherInfo,
    SuperMenu,
    AdvComponent,
    AppBar,
    ConsultCard
  },

  props: {},

  data() {
    return {
      page: 1,
      loading: false,
      finished: false,
      loaded: false,
      info: null,
      superMenuList: [],
      /* 资源位数据 */
      advData: [],
      /* 资源位背景色 */
      advBackground: '#ffffff',
      collect: false
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getDetailInfo()
    this.getBannerList()
  },

  mounted() {},

  destroyed() {},
  methods: {
    getSuperMenu() {
      let params = {
        page: this.page,
        pagenum: 20,
        cal_food_id: this.$route.query.foodid
      }
      this.$http
        .getApp('member/SuperRecipe/getSuperRecipePageByCalFood', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (!res.data.data.length) {
              this.finished = true
            } else {
              this.page++
            }
            this.superMenuList = this.superMenuList.concat(res.data.data)
          } else {
            this.finished = true
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false
        })
    },
    // 获取食物详情
    getDetailInfo() {
      if (this.$http._isApp()) {
        this.$http
          .getBaseApp('member/Food/FoodDetail', {
            foodid: this.$route.query.foodid
          })
          .then((rs) => {
            if (rs.data.code === 200) {
              this.info = rs.data.data
            } else {
              this.$dialog.alert({
                title: '提示',
                message: res.data.msg
              })
            }
          })
          .finally(() => {
            this.loaded = true
          })
      } else {
        this.$http
          .getApp('facility/calorie/FoodDetail', {
            foodid: this.$route.query.foodid
          })
          .then((rs) => {
            if (rs.data.code === 200) {
              this.info = rs.data.data
            } else {
              this.$dialog.alert({
                title: '提示',
                message: res.data.msg
              })
            }
          })
          .finally(() => {
            this.loaded = true
          })
      }
    },
    //获取资源位列表
    getBannerList() {
      let params = {
        lab_ids: this.$route.query.foodid, //食物id
        position_type: '18', //位置类型
        resource_type: '2' //资源位类型
      }
      this.$http
        .getAdvData(
          'member/ResourceLocation/getShowResourceLocationNew',
          params
        )
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.advData = res.data
          }
        })
        .catch((err) => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.adv-content {
  margin-top: 16px;
}

.tip {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 15px;
  line-height: 18px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
}

.van-list {
  background-color: #f7f7f7;
}

.food-info {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f7f7f7;
  padding-bottom: 10.7vw;
  overflow: hidden;

  .fi-top {
    width: 100%;
    box-sizing: border-box;
    padding: 4vw;
    background: #fff;

    .t-col {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .c-left {
        display: flex;
        align-items: center;

        .c-img {
          width: 10vw;
          height: 10vw;
          border-radius: 1vw;
          margin-right: 4vw;
        }

        .c-name {
          font-size: 4vw;
          font-weight: 600;
          color: #000;
        }
      }

      .c-right {
        display: flex;
        align-items: center;

        .r-dot {
          width: 2vw;
          height: 2vw;
          background-color: #49ceba;
          margin-right: 2vw;
          border-radius: 50%;
        }

        .r-title {
          font-size: 3vw;
          font-weight: 600;
          color: #000;
          margin-right: 1.1vw;
        }

        .r-que {
          font-size: 3vw;
          font-weight: 600;
          width: 4vw;
          height: 4vw;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border: solid 0.3vw #838aae;
          color: #838aae;
          opacity: 0.5;
          border-radius: 50%;
        }
      }
    }

    .t-label {
      width: 100%;
      box-sizing: border-box;
      margin-top: 1vw;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .la-item {
        margin-right: 3vw;
        margin-top: 3vw;
        display: flex;
        align-items: center;
        padding: 1vw 3vw;
        background-color: #f7f7f7;
        border-radius: 99vw;
        border: solid 0vw #f1f1f1;
        position: relative;
        color: rgba(0, 0, 0, 0.5);

        & i {
          margin-right: 2vw;
        }

        .iconxingxing1 {
          background-color: #49ceba;
          color: #fff;
          font-size: 2vw;
          padding: 0.8vw;
          border-radius: 50%;
        }

        .i-name {
          font-size: 12px;
          font-weight: 600;
        }

        .i-desc {
          text-align: left;
          width: max-content;
          max-width: 50vw;
          word-break: break-all;
          background-color: #fff;
          padding: 4vw;
          box-shadow: 0vw 0vw 1.9vw 0vw rgba(0, 0, 0, 0.06);
          border-radius: 1.6vw;
          color: rgba(0, 0, 0, 0.7);

          .d-title {
            font-size: 3.2vw;
            font-weight: 600;
          }

          .d-text {
            color: rgba(0, 0, 0, 0.5);
            margin-top: 1.3vw;
          }

          position: fixed;
          z-index: 19;
        }
      }

      .la-item-risk {
        background-color: #ff8282;
        color: #fff;

        .iconzhuyishixiang {
          font-size: 4.1vw;
          color: #fff;
          transform: rotate(180deg);
        }
      }
    }
  }
}

.super-menu {
  margin-top: 16px;
  margin-bottom: 30px;
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
